import { render, staticRenderFns } from "./balanceRecharge.vue?vue&type=template&id=5f047962&scoped=true&"
import script from "./balanceRecharge.vue?vue&type=script&lang=js&"
export * from "./balanceRecharge.vue?vue&type=script&lang=js&"
import style0 from "./balanceRecharge.vue?vue&type=style&index=0&id=5f047962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f047962",
  null
  
)

export default component.exports